




























module.exports = {
  props: ['filters']

  components:
    ozzyTaskItem: require('./list_item')

  data: ->
    tasks: []
    loading: false
    next_page: 2
    current_page: 1

  methods:
    nextPage: ->
      @loadTasks(@next_page)
      @current_page++

    prevPage: ->
      @loadTasks(@current_page-1)
      @current_page--

    taskUpdated: (task) ->
      @reloadTasks()
      EventsBus.$emit 'Task::Done', task

    loadTasks: (page) ->
      return if @loading
      @loading = true
      @tasks_resource.index(@loadTasksSuccess, @unknownError, params: { q: @filters, page: page, per: 6 })

    removeTask: ->
      @reloadTasks()

    loadTasksSuccess: (data) ->
      @tasks = data.tasks
      @next_page = data.meta.next_page
      @loading = false

    reloadTasks: ->
      if @tasks.length < 2
        @prevPage()
      else
        @loadTasks(@current_page)

  created: ->
    @tasks_resource = new TasksResource
    @loadTasks(@current_page)
    EventsBus.$on 'Task::Destroyed', @removeTask

  beforeDestroy: ->
    EventsBus.$off 'Task::Destroyed', @removeTask
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/ozzy_tasks/list.vue